import { MaintenanceAlert } from "components/common";
import { SnomedSearch } from "components/search";

const SnomedCTPage = () => {
  return (
    <>
      <MaintenanceAlert />
      <SnomedSearch />
    </>
  );
};

export default SnomedCTPage;
